


export const privacyContent = `
  <h3>Pro Bio Generator Privacy Policy</h3>
  <p>Your privacy is important to us.
  Read about our Privacy Policy below:</p>
  Last Updated: January 1, 2026

1. Introduction
Welcome to Pro Bio Generator ("we," "our," or "us"). We respect your privacy and are committed to protecting it. This Privacy Policy explains what information we collect when you use our website, biogen.com, and how we use it.

2. Information We Collect
Voluntary Information: We do not require a login. However, any text you enter into our generator (e.g., job titles or skills) is processed locally or temporarily to provide the service. We do not store this data on our permanent servers.

Automatically Collected Information: Like most websites, we collect certain info through cookies and web beacons, such as your IP address, browser type, and time spent on the site.

3. Google AdSense & Cookies
This website uses Google AdSense to display advertisements.

Google, as a third-party vendor, uses cookies to serve ads on this site.

Google's use of advertising cookies enables it and its partners to serve ads to users based on their visit to this site or other sites on the Internet.

Users may opt out of personalized advertising by visiting Google Ads Settings.

4. Third-Party Analytics
We may use tools like Google Analytics to monitor and analyze web traffic. These third parties have their own privacy policies regarding how they handle data.

5. California Consumer Privacy Act (CCPA)
Under the CCPA, California residents have the right to:

Request that a business delete personal data collected.

Request that a business that sells personal data, not sell the personal data.

If you wish to exercise these rights, please contact us.

6. GDPR Data Protection Rights
If you are located in the EEA, you have the right to access, rectify, or erase your personal data. Since we do not store personal profiles, the data we hold is typically limited to anonymous analytical data.

7. Contact Us
If you have any questions about this Privacy Policy, you can contact us at: Email: info@probiosgen.com</p>
`;

export default privacyContent;